import { render, staticRenderFns } from "./AttachmentsHandler.vue?vue&type=template&id=7484ecdd&scoped=true&"
import script from "./AttachmentsHandler.vue?vue&type=script&lang=js&"
export * from "./AttachmentsHandler.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsHandler.vue?vue&type=style&index=0&id=7484ecdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7484ecdd",
  null
  
)

export default component.exports